module.exports = __webpack_public_path__ + "static/media/community-icon-medium.9b7edbd1.svg";